// extracted by mini-css-extract-plugin
export default {"modal-header":"AddInventoryModell_modal-header__xj8rY","search-filter__markReceived":"AddInventoryModell_search-filter__markReceived__HgLgS"};